import dayjs, { Dayjs } from 'dayjs';
import { formatDate } from 'utils/date';

export const dateFormatter = <V extends (string | Date | Dayjs | undefined)>(value: V): string | undefined => {
  if (!value || !dayjs(value).isValid()) return;

  return formatDate(dayjs(value));
};
